module.exports = __webpack_public_path__ + "img/monterey_pulley_lift.e8ce448e.jpg";